import { Injectable, inject } from '@angular/core';
import { RoutingPermissionProvider } from '../providers/routing-permission-provider.service';
import { Route } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class RoutingPermissionService {
  private readonly provider = inject(RoutingPermissionProvider);

  public check(path: Route): boolean {
    const entry = this.provider.entry(path);

    return entry();
  }
}
